import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllexcessOrderThunk = createAsyncThunk(
    'excess/getAllexcessOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllexcessOrder(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getexcessOrderStatisticsThunk = createAsyncThunk(
    'excess/getexcessOrderStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getexcessOrderStatisticsdata(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const excessOrderDetailsThunk = createAsyncThunk(
    'excess/excessOrderDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getexcessOrderDetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportexcessOrderThunk = createAsyncThunk(
    'order/exportexcessOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllexcessOrder(config);
              console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteexcessOrderThunk = createAsyncThunk(
    'order/deleteexcessOrderThunk',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteexcessOrder(id);
            dispatch(setexcessOrderrefresh())
            toast.success('excess enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete excess enquiry')
        }
    }
);


export const updateOrderStatus = createAsyncThunk(
    'order/updateStatus',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateexcessOrderStatus(data);
            dispatch(setexcessOrderrefresh())
            toast.success('order updated  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update order')
        }
    }
);

const excessOrderSlice = createSlice({
    name: 'excessOrder',
    initialState: {
        excess: [],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setexcessOrderrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setexcessOrderPage: (state, action) => {
            state.page = action.payload
        },
        setexcessOrderSearch: (state, action) => {
            state.search = action.payload
        },
        setexcessOrderStatus: (state, action) => {
            state.status = action.payload
        },
        setexcessOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setexcessOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
        setexcessOrderSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setexcessOrderData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllexcessOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllexcessOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excess = action.payload;
            })
            .addCase(getAllexcessOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(excessOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(excessOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(excessOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportexcessOrderThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportexcessOrderThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportexcessOrderThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getexcessOrderStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getexcessOrderStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getexcessOrderStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setexcessOrderrefresh, setexcessOrderPage, setexcessOrderSearch, setexcessOrderStatus, setexcessOrderFromDate, setexcessOrderToDate, setexcessOrderSelectedTab, setexcessOrderData } = excessOrderSlice.actions
export default excessOrderSlice.reducer;

